<template>
  <div>
    <div class="form-group" v-if="stepType === 'trial'">
      <label class="custom-label">Promotion during test</label>
      <br>
      <custom-checkbox v-for="promo in promos"
        :key="`promo-${promo.id}`"
        :label="promo.name"
        :value="promo.id"
        :checked="promosDuringTest.includes(promo.id)"
        @input="$store.commit('changePromoDuringTest', $event)"
      >
      <template v-if="! nav">
        <documents-icon
          :communication="promo"
          checkedType="promoIsChecked"
          documentsType="promoHasDocuments"
          @openModal="$emit('openDocumentUploadModal', promo)"
        />
        <i class="far fa-comment-dots" style="margin-left: 8px; cursor: pointer;"
          v-if="promosDuringTest.includes(promo.id)"
          @click="openDescriptionModal(promo)"
        ></i>
      </template>
      </custom-checkbox>
    </div>
    <template v-else>
      <div class="class-form-group" v-if="! nav">
        <label class="custom-label">Roll Out Promotions</label>
        <br>
        <button class="btn btn-sm btn-primary"
          @click="openRollOutPromotionModal"
          style="margin-bottom: 6px;"
        >
          <i class="fa fa-plus"></i> Add
        </button>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-sm-3 text-center" v-for="promotion in rollOutPromotions"
            style="margin-top: 1rem;"
          >
            <p>
              <strong>{{ promotion.name }}</strong>
              <i class="fa fa-images" @click="openUploadModal(promotion)"></i>
            </p>
            <div style="white-space: pre-wrap;">{{ promotion.description }}</div>
            <br>
            <button class="btn btn-secondary btn-sm"
              @click="deletePromo(promotion)"
            >
              <i class="fa fa-trash-alt"></i>
            </button>
            <button class="btn btn-warning btn-sm"
              @click="editPromo(promotion)"
            >
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </div>
        <p v-if="! rollOutPromotions.length"
          style="margin-top: 8px;"
        >
          No promotions added
        </p>
      </div>

    </template>

    <div class="form-group">
      <label class="custom-label">Branding General</label>
      <br>
      <custom-checkbox v-for="branding in brandings"
        :key="`branding-${branding.key}`"
        :label="branding.label"
        :value="branding.key"
        :checked="$store.state[branding.key]"
        @input="$store.commit('changeBrandingGeneral', $event)"
      />
    </div>

    <custom-input
      label="Company Website"
      :value="companyWebsite"
      @input="$store.commit('changeCompanyWebsite', $event)"
    />

    <div style="margin-top: 1em;" v-if="nav">
      <button type="button" class="btn btn-primary float-left"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/5`)"
        v-text="'Back'"
      />
      <button type="button" class="btn btn-primary float-right"
        @click="createTest"
        v-text="stepType === 'trial' ? 'Create Test' : 'Create Roll Out'"
      />
    </div>
    <template v-else>
      <button class="btn btn-primary float-right"
        v-if="isAdmin || isFromAuthUser"
        @click.prevent="$emit('update')"
        style="margin-bottom: 1em;"
      >
        <i class="fa fa-edit"></i> Save
      </button>
    </template>
    <description-modal :promo="promo" v-if="promo"
      @saveDescription="saveDescription"
    />
    <roll-out-promotion-modal :rollOutId="rollOutId" :post="! nav"
      :key="showPromoModal"
    />
    <roll-out-promotion-edit-modal :rollOutId="rollOutId"
      :promotion="promoToEdit"
      :key="promoToEdit.id"
      @updated="updatePromo"
    />
    <roll-out-promotion-upload-modal :rollOutId="rollOutId" :promotionId="promotionId"
      :documents="blaDocuments" @fileUploaded="rollOutPromotionModalUploaded"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StepMixin from './step-mixin'

  export default {
    mixins: [ StepMixin ],
    props: {
      canUploadImages: {
        default: false,
      },
      trialPromos: { default() { return [] }},
      trialId: {
        default: null,
      },
      rollOutId: {
        default: null,
      },
    },
    data() {
      return {
        promos: [],
        brandings: [
          {
            label: 'Kodak Moments',
            key: 'kodakmoments',
          },
          {
            label: 'Co-Branding',
            key: 'co',
          },
          {
            label: 'Company Branding',
            key: 'company',
          },
        ],
        promo: null,
        promotionId: null,
        blaDocuments: [],
        showPromoModal: false,
        promoToEdit: {
          id: null,
          name: '',
          description: '',
          date: '',
        },
      }
    },
    computed: {
      ...mapState(['companyWebsite', 'promosDuringTest', 'rollOutPromotions']),
    },
    methods: {
      createTest() {
        const path = this.stepType === 'trial' ? '/trials' : '/roll_outs'
        axios.post(path, this.$store.getters.postData).then(res => {
          window.location.replace(path);
        })
      },
      openDescriptionModal(promo) {
        let existingPromo = this.trialPromos.find(ePromo => ePromo.id === promo.id)
        if (! existingPromo) {
          existingPromo = {
            id: promo.id,
            documents: [],
            pivot: {
              description: ''
            }
          }
          this.trialPromos.push(existingPromo)
        }
        this.promo = existingPromo
        this.$nextTick(() => $('#descriptionModal').modal('show'))
      },
      saveDescription(description) {
        window.axios.put(`/trials/${this.trialId}/promos/${this.promo.id}`, {description}).then(({data}) => {
          window.notification.success(`The description has been saved`, 'Success!')
          this.promo.pivot.description = data.pivot.description
          $('#descriptionModal').modal('hide')
        })
      },
      openRollOutPromotionModal() {
        this.showPromoModal = true
        this.$nextTick(() => $('#rollOutPromotionModal').modal('show'))
      },
      openUploadModal(promo) {
        this.promotionId = promo.id
        this.blaDocuments = promo.documents
        this.$nextTick(() => $('#rolloutPromotionUploadModal').modal('show'))
      },
      rollOutPromotionModalUploaded(file) {
        this.blaDocuments.push(file)
      },
      deletePromo({id}) {
        if (confirm('Do you really want to delete the promotion?')) {
          window.axios.delete(`/roll_outs/${this.rollOutId}/roll_out_promotions/${id}`).then(
            ({data}) => this.$store.commit('deleteRollOutPromotion', data)
          )
        }
      },
      editPromo(promo) {
        this.promoToEdit = promo
        this.$nextTick(() => $('#rollOutPromotionEditModal').modal('show'))
      },
      updatePromo(promo) {
        $('#rollOutPromotionEditModal').modal('hide')
        this.promoToEdit.name = promo.name
        this.promoToEdit.date = promo.date
        this.promoToEdit.description = promo.description
      }
    },
    mounted() {
      axios.get('/api/promos').then(({data}) => {
        this.promos = data;
      })
      $(document).on('hide.bs.modal', '#descriptionModal', () => {
        this.promo = null
      })
      $(document).on('hide.bs.modal', '#rollOutPromotionModal', () => {
        this.showPromoModal = false
      })
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep6.vue